var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shown)?_c('div',{staticClass:"overlay"},[_c('div',{ref:"modal",staticClass:"modal",style:({
        '--width': _vm.width,
        '--height': _vm.height,
      })},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }